module.exports = __webpack_public_path__ + "static/img/background_color.a40a4614.png";